import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { paymentFooterFeature } from './reducers/payment-footer.reducer';
import { EffectsModule } from '@ngrx/effects';
import { PaymentFooterEffects } from './effects/payment-footer.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(paymentFooterFeature),
    EffectsModule.forFeature([PaymentFooterEffects]),
  ],
})
export class PaymentFooterStoreModule {}
